import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { DaLinkModule } from '../da-link/da-link.module';
import { CheckoutListComponent } from './checkout-list.component';
import { CouponCodeModule } from '../coupon-code';

@NgModule({
    declarations: [CheckoutListComponent],
    exports: [CheckoutListComponent],
    imports: [CommonModule, DaLinkModule, RouterModule, TranslateModule.forChild(), LocalizeRouterModule.forChild([]), CouponCodeModule]
})
export class CheckoutListModule {}
